<ion-item *ngIf="!hide">
  <div class="c-label-inner">
    <div
      class="c-label-html"
      (click)="onClickPotentialImage($event)"
      [innerHtml]="label.content | fetchImageFromHtmlPipe:label.images | async | trustHtmlPipe">
    </div>
    <app-c-tooltip-button
      *ngIf="label.tooltip"
      c-field-tooltip
      [tooltip]="label.tooltip"></app-c-tooltip-button>
  </div>
</ion-item>
